/*---------------------------------------------------------------
 * This code is ported & tweaked from the apncore/competition.js
 * and is intended to populate the form from the user's logged
 * in account data.
 *-------------------------------------------------------------*/

;(function($, undefined){
    var rnn, log;

    /////////////////////////////////////////
    // Grabs user data and adds to fields
    /////////////////////////////////////////

    function populateUserData() {

        rnn.modules.user.get(function(user){
            if (user.authenticated) {

                //The old code had ID's...
                //and they are used by the backend's included livevalidation,
                //So lets just deal with it for now.
                $("#id_full_name").populate(user.first_name + ' ' + user.last_name);
                $("#id_phone").populate(user.phone);
                $("#id_email").populate(user.email);
                $("#id_postcode_autocomplete").populate(user.sensible_locality);
                $("#id_postcode_autocomplete_id").populate(user.locality_id);
                $("#id_first_name").populate(user.first_name);
                $("#id_last_name").populate(user.last_name);
                $("#id_street_address").populate(user.street_address);
                $("#id_country").populate(user.country);
                $("#id_country_id").populate(user.country_id);

                if (user.gender) {
                    $("#id_sex").populate(user.gender);
                }

                if (user.dob) {
                    var dob_split = user.dob.split("-",3),
                        now = new Date(),
                        dob = new Date(user.dob),
                        diff = now.getTime() - dob.getTime(),
                        age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25)),
                        age_range;

                    $("#id_dob_year").val(dob_split[0]);
                    $("#id_dob_month").val(parseInt(dob_split[1],10));
                    $("#id_dob_day").val(parseInt(dob_split[2],10));

                    if (age < 16) {
                        age_range = "0-16";
                    } else if (age > 16 && age <= 24) {
                        age_range = "16-24";
                    } else if (age >= 25 && age <= 39) {
                        age_range = "25-39";
                    } else if (age >= 40 && age <= 54) {
                        age_range = "40-54";
                    } else {
                        age_range = "55+";
                    }

                    $("#id_age_range").val(age_range);
                }
            }

            $(".form_population_message").remove();
        });

        /////////////////////////////
        // Custom delay execution
        /////////////////////////////
        // Delays the execution of jQuery code

        var delayedExecution = {
            execute: function(elem, func) {
                this.timeoutId = null;
                func.call(elem);
            },
            wait: function(elem, func) {
                if (this.timeoutId) {
                    window.clearTimeout(this.timeoutId);
                }
                var delayedExecution = this;
                this.timeoutId = window.setTimeout(function(){
                    delayedExecution.execute(elem, func);
                }, 1000);
            }
        };

        /////////////////
        // IE Hash fix
        /////////////////
        // fix ie bug, anchor hash being disrupted on competition submit.

        if (window.location.hash) {
            setTimeout( "window.location.href = window.location.href;", 100 );
        }

        cleanPhoneInputField();
    } //end of initPopulateUserdata

    function cleanPhoneInputField() {

        var $phoneInput = $('#id_phone');
        var inputType = 'phone';

        if ($phoneInput.length) {
            $phoneInput.keyup(function() {
                if (this.value.replace(/[^\d]/g, '') !== this.value) {
                    // Input contains either symbols, white spaces or letters
                    updateInputError("This is not a valid phone number. Please remove symbols and/or spaces.", this, inputType);
                } else if (this.value.length >= 2 && this.value.slice(0,2) === '61') {
                    updateInputError("This is not a valid phone number. Do not include a country code (61).", this, inputType);
                } else if (this.value.length > 10) {
                    updateInputError("This is not a valid phone number. Please enter a 10-digit mobile or landline number. If" +
                     " you're entering a landline number, please include the two-digit area code.", this, inputType);
                } else {
                    // Number is either a valid number, or a blank which is also valid
                    if ($("#js_" + inputType).length) {
                        $("#js_" + inputType).remove();
                    }
                }
            });
        }
    }

    function updateInputError(message, input, inputType) {
        /*
         * Function will check if there is an error for the input already, and update it,
         * otherwise it will create the error message.
        */
        var $errorSpan = $("#js_" + inputType);

        if ($errorSpan.length) {
            $errorSpan.text(message);
        } else {
            $("<span id='js_" + inputType + "' class='LV_validation_message LV_invalid'>" + message + "</span>").insertAfter(input);
        }
    }

    // Initialise Accounts
    function initCompetitions() {
        var $compForm = $("#competitionEntryForm");

        if ($compForm.length == 1) {
            populateUserData();

            $compForm.submit(function () {
                $('*[type="submit"]').prop('disabled', true).html('Submitting...');

                setTimeout(function(){
                  if($('.LV_invalid_field').length) {
                      $('*[type="submit"]').prop('disabled', false).html('Submit');
                  }
              }, 500);

            });
        }
    }

    rnn = window.rnn;

    log = rnn.logging.log;

    rnn.modules.register('competitions', {
        init: initCompetitions
    });

})(jQuery);
